import { Text } from '@mantine/core';
import type { WaRendererProps } from './primitives';

/** A reaction whose target message isn't on the loaded page — the thread docks
 *  reactions onto their target when it is, so this is only the orphan case. */
export function ReactionMessage({ view }: WaRendererProps) {
  return <Text size="lg">{view.reactionEmoji ?? '👍'}</Text>;
}
